/* valueSelect.ts */

/* Interfaces */
import { BasicProps } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

export const getFilterLabel = (segment: BasicProps) => {
  const { value, values, boundaries } = segment;

  return String(value)
    ? "Value"
    : String(values)
    ? "Values"
    : String(boundaries)
    ? "Boundaries"
    : "";
};
